import eventHandlers from "@/events/global-event-handlers"
import globalEvents from "@/events/global-events"
import Vue from "vue"

interface EventBus {
  $emit(..._args: any[]): any
  $on(..._args: any[]): any
  $off(..._args: any[]): any
}

const eventBus: EventBus = new Vue()

eventBus.$on(globalEvents.LOG_IN, eventHandlers.handleLogInEvent)
eventBus.$on(globalEvents.LOG_OUT, eventHandlers.handleLogOutEvent)

export default eventBus
